export const addZipcodeButton = 'Add zip code';
export const errorRemovingZipcode = 'Error removing zip code!';
export const successRemovingZipcode = (zipCode) => `Removed zip code: ${zipCode}`;
export const successAddZipcode = (zipCode) => `Added ${zipCode}`;
export const successClickZip = (GEOID) => `Clicked ${GEOID}!`;
